<app-data-table mainTitle="Comissão Tipo"
                singleTitle="Comissão Tipo"
                routerPath="/comissao-tipo"
                entityPath="/comissaotipo"
                [entity]="comissaoTipo"
                [entityFilter]="entityFilter"
                [columns]="this['columns']"
                [controls]="this['controls']">
</app-data-table>
